import { forwardRef, useMemo } from "react"
import BottomSheet, {
  BottomSheetModal,
} from '@gorhom/bottom-sheet';
import React from "react";
import { Text, View, FlatList, Pressable } from 'react-native';
import styles from "@stylesheet";
import { useQuery } from "@tanstack/react-query";
import apis from "@api/api";
import { Title } from "@constants/Themed";

const EmailComposeModal = forwardRef<BottomSheet>((props: any, ref) => {
  
  const snapPoints = useMemo(() => ['90%'], []);

  const { status, data: emailTemplates, error, isFetching, isLoading, refetch } = useQuery({
    queryKey: ['emailTemplates'],
    queryFn: async () => {
      const data = await apis.getEmailTemplates()
        .then(res => {
          return res
        });
      return data
    },
  })

  const _renderItem = ({ item, index }) => {
    return (
      <Pressable style={{ backgroundColor: 'white', borderRadius: 20, shadowRadius: 20, shadowOpacity: 0.2, elevation: 10 }}>
        <Text>{item.templateTitle}</Text>
        <Text>{item.createdAt}</Text>
      </Pressable>
    )
  }

  return (
    <BottomSheetModal
      snapPoints={snapPoints}
      index={0}
      ref={ref}
      enablePanDownToClose
      style={[styles.bottomSheet]}
    >
      <View style={{ backgroundColor: 'white', flex: 1, padding: 20, borderRadius: 20 }}>
        <Title>Select email template</Title>
        <FlatList data={emailTemplates} renderItem={_renderItem} horizontal contentContainerStyle={{ maxHeight: 150 }} style={{ flex: 1 }} />
      </View>
    </BottomSheetModal>)
})
export default EmailComposeModal;